export default {
  'cardholder.details.consent': 'Consent',
  'cardholder.details.consent.label': 'To generate the consent please press the button below.',
  'cardholder.details.consent.success': 'Great! You have successfully signed the contract.',
  'cardholder.details.consent.fetching': 'We are fetching the information from DocuSign',
  'cardholder.details.consent.generate': 'Generate Cardholder Consent',
  'cardholder.details.consent.processing': 'Processing your contract signing with DocuSign. The signed contract will load once signing process is complete.',
  'cardholder.details.consent.docusign': 'Sign with DocuSign',
  'cardholder.details.consent.declined': "The contract has been declined in DocuSign. Press on 'Close' button below to reload this page and try again.",
  'cardholder.details.consent.failed': "Failed to fetch information from DocuSign. Press on 'Close' button below to reload this page and try again.",
};
